import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";

import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CloseIcon from "@mui/icons-material/Close";
import { TabView, TabPanel } from "primereact/tabview";
import axios from "axios";
import formattedDate from "../../formatDate";
import { Dialog } from "primereact/dialog";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import "primeicons/primeicons.css";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Tag } from "primereact/tag";
import mapEtatFiche from "../../mapEtatFiche";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { fr } from "date-fns/locale";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TextField, TextareaAutosize } from "@mui/material";
import formatToISODate from "../../formatDateISO";
import { useParams } from "react-router-dom";
import PdfButton from ".././pdfGenerator";
import { updateEnLigne } from "../projetService";
import { Dropdown } from "primereact/dropdown";
import mapTrajet from "../../mapTrajet";
import { Calendar } from "primereact/calendar";
import mapStatus from "../mapStatus";
import Log from "./journaux";

import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";

import sqlDateToJS from "./sqlDateToJS";
import sqlTimeToJS from "./sqlTimeToJS";



const apiUrl = process.env.REACT_APP_API_URL;

const canSelect = true;

export default function EnAttentes() {
  const [editMode, setEditMode] = useState(false);

  const [copied, setCopied] = useState(false);
  const [copiedText, setCopiedText] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const [dateMAJ, setDateMAJ] = useState("");
  const [infoMAJ, setInfoMAJ] = useState("");

  const [rechercheEnAttentes, setRechercheEnAttentes] = useState("");

  const [projets, setProjets] = useState([]);

  const [enAttentes, setEnAttentes] = useState([]);
  const [enAttente, setEnAttente] = useState([]);

  const [filtreEnAttente, setFiltreEnAttente] = useState([enAttentes]);

  const [visible, setVisible] = useState(false);

  const [etat, setEtat] = useState([]);
  const [note, setNote] = useState([]);

  const [tempIdNavette, setTempIdNavette] = useState("");
  const [tempStatus, setTempStatus] = useState("");
  const [tempNom, setTempNom] = useState("");
  const [tempTel, setTempTel] = useState("");
  const [tempType, setTempType] = useState("");
  const [tempTrajet, setTempTrajet] = useState("");
  const [tempLieu, setTempLieu] = useState("");

   const [tempAdresse, setTempAdresse] = useState("");
   const [tempNb_bag_soute, setTempNb_bag_soute] = useState("");
   const [tempNb_bag_cabine, setTempNb_bag_cabine] = useState("");
   const [tempInfoSup, setTempInfoSup] = useState("");
   const [tempNb_passager, setTempNb_passager] = useState("");
   const [tempPaye, setTempPaye] = useState("");
  

  const [chauffeurs, setChauffeurs] = useState("");
  const [chauffeurSelected, setChauffeurSelected] = useState("");

  const [trajetBr, setTrajetBr] = useState("");
  const [tempTotal, setTempTotal] = useState("");

  const [dateDepart,setDateDepart] = useState("");
  const [heureDepart, setHeureDepart] = useState("");

  const trajetOptions = [
    { label: "Aller simple", value: "Aller simple" },
    { label: "Aller-Retour", value: "Aller - Retour" },
    // { label: 'Mise à disposition', value: 'Mise à disposition' }
  ];

  const trajetDetail = [
    {
      label: "Dom ➜ Aero",
      value: "Depuis mon domicile à l'Aéroport Roland-Garros (RUN)",
    },
    {
      label: "Aero ➜ Dom",
      value: "De l'Aéroport Roland-Garros (RUN) à mon domicile",
    },
  ];

  const [infoSup, setInfoSup] = useState("");

  const [filtreChauffeurs, setFiltreChauffeurs] = useState("");

  useEffect(() => {
    fetch(`${apiUrl}IHM/api/navettes.php?enAttentes=1`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setEnAttentes(data.projets);
        }
      })
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    fetch(`${apiUrl}IHM/api/chauffeurs.php?AllChauffeurs`)
      .then((res) => res.json())
      .then((data) => {
        setChauffeurs(Array.isArray(data) ? data : []);
      })
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    const rechercheMin = rechercheEnAttentes.toLowerCase();
    const filteredList = enAttentes.filter((projet) => {
      const nom = projet.nom_prenom?.toLowerCase() || "";
      const telephone = projet.numero_tel?.toLowerCase() || "";

      return nom.includes(rechercheMin) || telephone.includes(rechercheMin);
    });
    setFiltreEnAttente(filteredList);
  }, [rechercheEnAttentes, enAttentes]);

  const enteteTabeau1 = () => {
    return (
      <div className="flex justify-content-end">
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText
            value={rechercheEnAttentes}
            onChange={(e) => setRechercheEnAttentes(e.target.value)}
            placeholder="Rechercher"
          />
        </IconField>
      </div>
    );
  };

  const copyToClipboard = (text) => {
    if (text !== "") {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            setCopiedText(text);
            setOpenSnackbar(true);
          })
          .catch((error) => {
            console.error(
              "Erreur lors de la copie dans le presse-papiers : ",
              error
            );
          });
      } else {
        // Utiliser l'API de sélection de texte comme solution de secours
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);

        setCopiedText(text);
        setOpenSnackbar(true);
      }
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const setInfoClick = (idNavette, nom, tel) => {
    setTempIdNavette(idNavette);
    setTempNom(nom);
    setTempTel(tel);

    setTempStatus("");
    setTempType("");
    setTempTrajet("");
    setTrajetBr("");
    setTempLieu("");
    setTempTotal("");

    setTempAdresse("");
    setTempNb_bag_soute("");
    setTempNb_bag_cabine("");
    setTempInfoSup("");
    setTempNb_passager("");
  setDateDepart("");
    setHeureDepart("");
    axios
      .get(`${apiUrl}IHM/api/navettes.php?idNavette=${idNavette}`)
      .then((response) => {
        setTempStatus(mapStatus(response.data[0].partiale));
        setTempType(response.data[0].type_trajet);
        setTempLieu(response.data[0].lieu_trajet);
        setTempTrajet(mapTrajet(response.data[0].trajet_detail));

        setTrajetBr(response.data[0].trajet_detail);
        setTempTotal(response.data[0].prix_total);

        setTempAdresse(response.data[0].adresse);
        setTempNb_bag_soute(response.data[0].nb_bag_soute);
        setTempNb_bag_cabine(response.data[0].nb_bag_cabine);
        setTempInfoSup(response.data[0].infoSup);
        setTempNb_passager(response.data[0].nb_passagers);

         if (response.data[0].date_depart) {
                  setDateDepart(sqlDateToJS(response.data[0].date_depart));
                }
                if (response.data[0].heure_depart) {
                  setHeureDepart(sqlTimeToJS(response.data[0].heure_depart));
                }

        setVisible(true);
      })
      .catch((error) => {
        console.error(
          "Une erreur s'est produite lors de la récupération de la fiche :",
          error
        );
      });
  };

  const handleSavePhoneCall = async () => {
    if (!chauffeurSelected && etat === "0") {
      alert("Le chauffeur n'a pas été séléctionné");
      return;
    }

    let data = {
      idNavette: tempIdNavette,
      etat: etat,
      note: note,
      adminMod: localStorage.getItem("us"),
    };
    if (etat === "0") {
      data.chauffeur = chauffeurSelected;
    }

    try {
      let response = await axios.put(`${apiUrl}IHM/api/navettes.php`, data);

      if (response.data) {
        setVisible(false);
        window.location.reload();
      } else {
        setVisible(false);
        window.location.reload();
      }
    } catch (error) {}
  };

  const header = (
    <div className="flex justify-between items-center w-full">
      <span className="font-semibold text-lg mr-2">Fiche de navette</span>
      <div className="flex items-center gap-2">
        <span style={{ cursor: "pointer" }}>
           {editMode ? (
                                 <>
                                   <span
                                     onClick={() => handleValidate()}
                                     style={{
                                       border: "1px solid #22c55e",
                                       borderRadius: "50%",
                                       color: "#fff",
                                       width: "28px",
                                       height: "28px",
                                       display: "inline-flex",
                                       alignItems: "center",
                                       justifyContent: "center",
                                       cursor: "pointer",
                                       marginRight: "8px",
                                       transition: "all 0.2s ease",
                                  
                                       backgroundColor: "#22c55e"
                                     }}
                                     onMouseEnter={(e) => {
                                       e.currentTarget.style.backgroundColor = "#22c55e";
                                       e.currentTarget.style.color = "#fff";
                                     }}
                                   >
                                     <CheckIcon sx={{ fontSize: 16 }} />
                                   </span>
                     
                                   <span
                                     onClick={() => setEditMode(false)}
                                     style={{
                                       border: "1px solid #ef4444",
                                       borderRadius: "50%",
                                       color: "#ffffffff",
                                       width: "28px",
                                       height: "28px",
                                       display: "inline-flex",
                                       alignItems: "center",
                                       justifyContent: "center",
                                       cursor: "pointer",
                                       transition: "all 0.2s ease",
                                       backgroundColor: "#ef4444"
                     
                                     }}
                                     onMouseEnter={(e) => {
                                       e.currentTarget.style.backgroundColor = "#ef4444";
                                       e.currentTarget.style.color = "#fff";
                                     }}
                                    
                                   >
                                     <CloseIcon sx={{ fontSize: 16 }} />
                                   </span>
                                 </>
                               ) : (
                                 <span
                                   style={{
                                     border: "1px solid #4b5563",
                                     borderRadius: "50%",
                                     color: "#ffffffff",
                                     width: "28px",
                                     height: "28px",
                                     display: "inline-flex",
                                     alignItems: "center",
                                     justifyContent: "center",
                                     cursor: "pointer",
                                     marginRight: "8px",
                                     transition: "all 0.2s ease",
                                     backgroundColor: "#4b5563"
                                   }}
                                   onMouseEnter={(e) => {
                                     e.currentTarget.style.backgroundColor = "#4b5563";
                                     e.currentTarget.style.color = "#fff";
                                   }}
                                   onClick={() => setEditMode(true)}
                                 >
                                   {" "}
                                   <EditIcon sx={{ fontSize: 16 }} />{" "}
                                 </span>
                               )}
        </span>
      </div>
    </div>
  );

  const handleValidate = async () => {

const formattedDate = dateDepart instanceof Date 
    ? `${dateDepart.getFullYear()}-${String(dateDepart.getMonth() + 1).padStart(2, '0')}-${String(dateDepart.getDate()).padStart(2, '0')}` 
    : null;

  const formattedHeure = heureDepart instanceof Date ? heureDepart.toTimeString().split(' ')[0] : null;
    let data = {
      idNavette: tempIdNavette,
      nomPrenom: tempNom,
      tel: tempTel,
      typeTrajet: tempType,
      detailTrajet: trajetBr,
      lieu: tempLieu,
      total: tempTotal,
      infoSup: infoSup,
      adresse :tempAdresse,
      nb_passagers: tempNb_passager,
      bag_soute: tempNb_bag_soute,
      bag_cabine: tempNb_bag_cabine,
      paye : tempPaye,
      adminNote : localStorage.getItem("us"),
      dateDepart: formattedDate,
      heureDepart: formattedHeure,
      note: note,
    };

    try {
      await axios.post(
        `${apiUrl}IHM/api/postUpdate/updateFicheNavette.php`,
        data
      );
      setEditMode(false);
      window.location.reload();
    } catch (error) {
      console.error("Erreur de mise à jour :", error);
      alert("Erreur lors de la sauvegarde");
    } finally {
    }
  };

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openSnackbar}
        autoHideDuration={1000}
        onClose={handleCloseSnackbar}
        message={`Copie réussie de " ${
          copiedText === "location.mail" ? "e-mail" : copiedText
        } "`}
        action={
          <React.Fragment>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleCloseSnackbar}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />

      <Dialog
        blockScroll
        visible={visible}
        header={header}
        className="custom-dialog"
        style={{ width: "40vw" }}
        modal
        onHide={() => {
          setVisible(false);
          setEditMode(false);
        }}
        breakpoints={{ "960px": "100vw", "640px": "100vw" }}
      >
        {editMode ? (
          <div className="p-3">
            <div className="grid">
              <div className="col-12 md:col-6">
                <label className="font-bold block mb-2 text-sm text-600">
                  Nom et Prénoms
                </label>
                <div className="p-inputgroup">
                  <InputText
                    value={tempNom}
                    onChange={(e) => setTempNom(e.target.value)}
                    placeholder="Nom du client"
                    disabled={!editMode}
                  />
                </div>
              </div>

              <div className="col-12 md:col-6 mb-3">
                <label className="font-bold block mb-2 text-sm text-600">
                  Type de trajet
                </label>
                <Select
                  value={tempType}
                  onChange={(e) => setTempType(e.target.value)}
                  displayEmpty
                  disabled={!editMode}
                  style={{ width: "100%", height: "40px" }}
                >
                  <MenuItem value="" disabled>
                    Sélectionner type
                  </MenuItem>
                  {trajetOptions.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                      {opt.label}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </div>

            {/* Ligne 2 */}
            <div className="grid">
              <div className="col-12 md:col-6">
                <label className="font-bold block mb-2 text-sm text-600">
                  Téléphone
                </label>
                <div className="p-inputgroup">
                  <InputText
                    value={tempTel}
                    onChange={(e) => setTempTel(e.target.value)}
                    placeholder="Ex: 06..."
                    disabled={!editMode}
                  />
                </div>
              </div>

              <div className="col-12 md:col-6">
                <label className="font-bold block mb-2 text-sm text-600">
                  Détail du trajet
                </label>
                <Select
                  value={trajetBr}
                  onChange={(e) => setTrajetBr(e.target.value)}
                  displayEmpty
                  disabled={!editMode}
                  style={{ width: "100%", height: "40px" }}
                >
                  <MenuItem value="" disabled>
                    Sélectionner détail du trajet
                  </MenuItem>
                  {trajetDetail.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                      {opt.label}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </div>

            {/* Ligne 3 */}
            <div className="grid">
              <div className="col-12 md:col-6">
                <label className="font-bold block mb-2 text-sm text-600">
                  Adresse
                </label>
                <InputText
                  value={tempAdresse}
                  onChange={(e) => setTempAdresse(e.target.value)}
                  placeholder="Adresse"
                  disabled={!editMode}
                />
              </div>

              <div className="col-12 md:col-6">
                <label className="font-bold block mb-2 text-sm text-600">
                  Ville
                </label>
                <InputText
                  value={tempLieu}
                  onChange={(e) => setTempLieu(e.target.value)}
                  placeholder="Ville"
                  disabled={!editMode}
                />
              </div>
            </div>

            <div className="grid">
              <div className="col-12 md:col-6">
                <label className="font-bold block mb-2 text-sm text-600">
                  Prix course
                </label>
                <InputNumber
                  value={tempTotal}
                  mode="currency"
                  currency="EUR"
                  onChange={(e) => setTempTotal(e.value)}
                  placeholder="Total"
                  disabled={!editMode}
                />
              </div>

              <div className="col-12 md:col-6">
                <label className="font-bold block mb-2 text-sm text-600">
                  Reste à payer
                </label>
                <InputNumber
                  value={tempPaye}
                  onChange={(e) => setTempPaye(e.value)}
                  mode="currency"
                  currency="EUR"
                  placeholder="Reste à payer"
                  disabled={!editMode}
                />
              </div>
            </div>

            <div className="grid">
              <div className="col-12 md:col-6">
                <label className="font-bold block mb-2 text-sm text-600">
                  Date départ
                </label>
                <Calendar
                  value={dateDepart}
                  onChange={(e) => setDateDepart(e.value)}
                  inputMode="none"
                  locale="fr"
                  dateFormat="dd/mm/yy"
                />
              </div>

              <div className="col-12 md:col-6">
                <label className="font-bold block mb-2 text-sm text-600">
                  Heure de départ
                </label>
                <Calendar
                  id="calendar-timeonly"
                  value={heureDepart}
                  onChange={(e) => setHeureDepart(e.value)}
                  timeOnly
                  showSeconds={false}
                  inputMode="none"
                />
              </div>
            </div>

            <div className="grid">
              <div className="col-12 md:col-6">
                <label className="font-bold block mb-2 text-sm text-600">
                  Nb bagages soute
                </label>
                <InputNumber
                  value={tempNb_bag_soute}
                  onChange={(e) => setTempNb_bag_soute(e.value)}
                  placeholder="0"
                  disabled={!editMode}
                />
              </div>

              <div className="col-12 md:col-6">
                <label className="font-bold block mb-2 text-sm text-600">
                  Nb bagages cabine
                </label>
                <InputNumber
                  value={tempNb_bag_cabine}
                  onChange={(e) => setTempNb_bag_cabine(e.value)}
                  placeholder="0"
                  disabled={!editMode}
                />
              </div>
            </div>

            <div className="grid">
              <div className="col-12 md:col-6">
                <label className="font-bold block mb-2 text-sm text-600">
                  Nb passagers
                </label>
                <InputNumber
                  value={tempNb_passager}
                  onChange={(e) => setTempNb_passager(e.value)}
                  placeholder="0"
                  disabled={!editMode}
                />
              </div>
            </div>

            <div className="grid">
              <div className="col-12 md:col-12">
                <div className="py-0 px-0 border-round-sm surface-100 flex flex-column">
                  <span className="font-bold">
                    Informations suplémentaires sur le vol :
                  </span>
                </div>
              </div>
            </div>

            <div className="grid">
              <div className="col-12 md:col-12">
                <TextareaAutosize
                  variant="standard"
                  minRows={5}
                  maxRows={10}
                  value={infoSup}
                  onChange={(e) => setInfoSup(e.target.value)}
                  style={{ width: "100%", borderRadius: "5px" }}
                  className="mt-2"
                />
              </div>
            </div>

            <div className="grid">
              <div className="col-12 md:col-12">
                <div className="py-0 px-0 border-round-sm surface-100 flex flex-column">
                  <span className="font-bold">Ajouter une note :</span>
                </div>
              </div>
            </div>

            <div className="grid">
              <div className="col-12 md:col-12">
                <TextareaAutosize
                  variant="standard"
                  minRows={5}
                  maxRows={10}
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                  style={{ width: "100%", borderRadius: "5px" }}
                  className="mt-2"
                />
              </div>
            </div>

            <div className="grid">
              <div className="col-12 md:col-12">
                <div className="border-round-sm surface-100 flex flex-column"></div>
                <Button
                  label="Modifier la fiche"
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#094ed8";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "#2563eb";
                  }}
                  className="w-full text-white"
                  style={{
                    background: "#2563eb",
                    border: "1px solid #2563eb",
                    padding: "0.75rem",
                    borderRadius: "5px",
                  }}
                  onClick={() => {
                    handleValidate();
                  }}
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="p-3">
            <div className="grid">
              <div className="col-12 md:col-6">
                <div className="p-2 px-0 surface-100 border-round-sm flex justify-between align-items-left">
                  <span className="font-bold">État actuel :</span>
                  <span
                    className="p-1 px-2 text-sm"
                    style={{ background: "#e5e7eb", borderRadius: "5px" }}
                  >
                    {tempStatus}
                  </span>
                </div>
              </div>

              <div className="col-12 md:col-6">
                <div className="p-2 px-0 surface-100 border-round-sm flex justify-between align-items-left">
                  <span className="font-bold">État souhaité :</span>
                  <Select
                    labelId="etat-label"
                    id="etat-select"
                    value={etat}
                    onChange={(e) => setEtat(e.target.value)}
                    displayEmpty
                    style={{
                      minWidth: "130px",
                      maxWidth: "130px",
                      maxHeight: "20px",
                    }}
                  >
                    <MenuItem value="" disabled>
                      Séléctionner un état
                    </MenuItem>
                    <MenuItem value="1">Partielle</MenuItem>
                    <MenuItem value="0">En cours</MenuItem>
                    <MenuItem value="2">Terminée</MenuItem>
                  </Select>
                </div>
              </div>
            </div>

            <div className="grid">
              <div className="col-12 md:col-6">
                <div
                  className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                  style={{ background: "#f9fafb", borderRadius: "5px" }}
                >
                  <span className="font-bold">Nom :</span>
                  <span
                    onClick={() => copyToClipboard(tempNom)}
                    className="cursor-pointer ml-1"
                  >
                    {tempNom} <ContentCopyIcon sx={{ fontSize: 12 }} />
                  </span>
                </div>
              </div>

              <div className="col-12 md:col-6">
                <div
                  className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                  style={{ background: "#f9fafb", borderRadius: "5px" }}
                >
                  <span className="font-bold">Type de trajet :</span>
                  <span
                    onClick={() => copyToClipboard(tempType)}
                    className="cursor-pointer ml-1"
                  >
                    {tempType} <ContentCopyIcon sx={{ fontSize: 12 }} />
                  </span>
                </div>
              </div>
            </div>

            {/* Ligne 2 */}
            <div className="grid">
              <div className="col-12 md:col-6">
                <div
                  className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                  style={{ background: "#f9fafb", borderRadius: "5px" }}
                >
                  <span className="font-bold">Téléphone :</span>
                  <span
                    onClick={() => copyToClipboard(tempTel)}
                    className="cursor-pointer ml-1"
                  >
                    {tempTel} <ContentCopyIcon sx={{ fontSize: 12 }} />
                  </span>
                </div>
              </div>

              <div className="col-12 md:col-6">
                <div
                  className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                  style={{ background: "#f9fafb", borderRadius: "5px" }}
                >
                  <span className="font-bold">Trajet :</span>
                  <span
                    onClick={() => copyToClipboard(tempTrajet)}
                    className="cursor-pointer ml-1"
                  >
                    {tempTrajet} <ContentCopyIcon sx={{ fontSize: 12 }} />
                  </span>
                </div>
              </div>
            </div>

            {/* Ligne 3 */}
            <div className="grid">
              <div className="col-12 md:col-6">
                <div
                  className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                  style={{ background: "#f9fafb", borderRadius: "5px" }}
                >
                  <span className="font-bold">Adresse :</span>
                  <span
                    onClick={() => copyToClipboard(tempAdresse)}
                    className="cursor-pointer ml-1"
                  >
                    {tempAdresse} <ContentCopyIcon sx={{ fontSize: 12 }} />
                  </span>
                </div>
              </div>

              <div className="col-12 md:col-6">
                <div
                  className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                  style={{ background: "#f9fafb", borderRadius: "5px" }}
                >
                  <span className="font-bold">Ville :</span>
                  <span
                    onClick={() => copyToClipboard(tempLieu)}
                    className="cursor-pointer ml-1"
                  >
                    {tempLieu} <ContentCopyIcon sx={{ fontSize: 12 }} />
                  </span>
                </div>
              </div>
            </div>

            <div className="grid">
              <div className="col-12 md:col-6">
                <div
                  className="p-2 px-0 border-round-sm flex align-items-left"
                  style={{ background: "#f9fafb", borderRadius: "5px" }}
                >
                  <span className="font-bold">Date de départ :</span>
                  <span
                    onClick={() => {
                      const val =
                        dateDepart instanceof Date
                          ? dateDepart.toLocaleDateString("fr-FR")
                          : dateDepart;
                      copyToClipboard(val);
                    }}
                    className="cursor-pointer ml-1"
                  >
                    <span>
                      {dateDepart instanceof Date
                        ? dateDepart.toLocaleDateString("fr-FR")
                        : dateDepart
                        ? dateDepart
                        : "--/--/----"}
                    </span>
                    <ContentCopyIcon sx={{ fontSize: 14 }} />
                  </span>
                </div>
              </div>

              <div className="col-12 md:col-6">
                <div
                  className="p-2 px-0 border-round-sm flex  align-items-left"
                  style={{ background: "#f9fafb", borderRadius: "5px" }}
                >
                  <span className="font-bold">Heure de départ :</span>
                  <span
                    onClick={() => {
                      const val =
                        heureDepart instanceof Date
                          ? heureDepart.toLocaleTimeString("fr-FR", {
                              hour: "2-digit",
                              minute: "2-digit",
                            })
                          : heureDepart;
                      copyToClipboard(val);
                    }}
                  >
                    {heureDepart instanceof Date
                      ? heureDepart.toLocaleTimeString("fr-FR", {
                          hour: "2-digit",
                          minute: "2-digit",
                        })
                      : heureDepart
                      ? heureDepart.substring(0, 5)
                      : "--:--"}

                    <ContentCopyIcon sx={{ fontSize: 12 }} />
                  </span>
                </div>
              </div>
            </div>

            <div className="grid">
              <div className="col-12 md:col-6">
                <div
                  className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                  style={{ background: "#f9fafb", borderRadius: "5px" }}
                >
                  <span className="font-bold">Prix course:</span>
                  <span
                    onClick={() => copyToClipboard(tempTotal)}
                    className="cursor-pointer ml-1"
                  >
                    {tempTotal} € <ContentCopyIcon sx={{ fontSize: 12 }} />
                  </span>
                </div>
              </div>

              <div className="col-12 md:col-6">
                <div
                  className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                  style={{ background: "#f9fafb", borderRadius: "5px" }}
                >
                  <span className="font-bold">Reste à payer :</span>
                  <span
                    onClick={() =>
                      copyToClipboard((tempTotal - tempPaye).toFixed(2))
                    }
                    className="cursor-pointer ml-1"
                  >
                    {(tempTotal - tempPaye).toFixed(2)} €{" "}
                    <ContentCopyIcon sx={{ fontSize: 12 }} />
                  </span>
                </div>
              </div>
            </div>

            <div className="grid">
              <div className="col-12 md:col-6">
                <div
                  className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                  style={{ background: "#f9fafb", borderRadius: "5px" }}
                >
                  <span className="font-bold">Nb bagages soute :</span>
                  <span
                    onClick={() => copyToClipboard(tempNb_bag_soute)}
                    className="cursor-pointer ml-1"
                  >
                    {tempNb_bag_soute} <ContentCopyIcon sx={{ fontSize: 12 }} />
                  </span>
                </div>
              </div>

              <div className="col-12 md:col-6">
                <div
                  className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                  style={{ background: "#f9fafb", borderRadius: "5px" }}
                >
                  <span className="font-bold">Nb bagages cabine :</span>
                  <span
                    onClick={() => copyToClipboard(tempNb_bag_cabine)}
                    className="cursor-pointer ml-1"
                  >
                    {tempNb_bag_cabine}{" "}
                    <ContentCopyIcon sx={{ fontSize: 12 }} />
                  </span>
                </div>
              </div>
            </div>

            <div className="grid">
              <div className="col-12 md:col-6">
                <div
                  className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                  style={{ background: "#f9fafb", borderRadius: "5px" }}
                >
                  <span className="font-bold">Nb passagers :</span>
                  <span
                    onClick={() => copyToClipboard(tempNb_passager)}
                    className="cursor-pointer ml-1"
                  >
                    {tempNb_passager} <ContentCopyIcon sx={{ fontSize: 12 }} />
                  </span>
                </div>
              </div>

              <div className="col-12 md:col-6">
                <div
                  className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                  style={{ background: "#f9fafb", borderRadius: "5px" }}
                >
                  <span className="font-bold">Info du vol :</span>
                  <span
                    onClick={() => copyToClipboard(tempInfoSup)}
                    className="cursor-pointer ml-1"
                  >
                    {tempInfoSup} <ContentCopyIcon sx={{ fontSize: 12 }} />
                  </span>
                </div>
              </div>
            </div>

            {etat === "0" && (
              <div className="grid">
                <div className="col-12">
                  <div className="p-2 px-0 surface-100 border-round-sm flex justify-between align-items-left">
                    <span className="font-bold">Attribution de chauffeur:</span>

                    <Select
                      labelId="etat-label"
                      id="etat-select"
                      value={chauffeurSelected}
                      onChange={(e) => setChauffeurSelected(e.target.value)}
                      displayEmpty
                      style={{
                        minWidth: "400px",
                        maxWidth: "400px",
                        maxHeight: "40px",
                        marginLeft: "10px",
                      }}
                    >
                      <MenuItem value="" disabled>
                        Séléctionner un chauffeur
                      </MenuItem>
                      {chauffeurs.map((chauffeur) => (
                        <MenuItem
                          key={chauffeur.idChauffeur}
                          value={chauffeur.idChauffeur}
                        >
                          {chauffeur.nomPrenom}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                </div>
              </div>
            )}

            <div className="grid">
              <div className="col-12 md:col-12">
                <div className="py-0 px-0 border-round-sm surface-100 flex flex-column">
                  <span className="font-bold">Ajouter une note :</span>
                </div>
              </div>
            </div>
            <div className="grid">
              <div className="col-12 md:col-12">
                <TextareaAutosize
                  variant="standard"
                  minRows={5}
                  maxRows={10}
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                  style={{ width: "100%", borderRadius: "5px" }}
                  className="mt-2"
                />
              </div>
            </div>

            <div className="grid">
              <div className="col-12 md:col-12">
                <div className="border-round-sm surface-100 flex flex-column"></div>
                <Button
                  label="Enregistrer l'état et la note"
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#094ed8";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "#2563eb";
                  }}
                  className="w-full text-white"
                  style={{
                    background: "#2563eb",
                    border: "1px solid #2563eb",
                    padding: "0.75rem",
                    borderRadius: "5px",
                  }}
                  onClick={() => {
                    if (etat) {
                      handleSavePhoneCall();
                    }
                  }}
                />
              </div>
            </div>
            <Log idProjet={tempIdNavette} />
          </div>
        )}
      </Dialog>

      <DataTable
        value={filtreEnAttente}
        size="small"
        paginator
        rows={25}
        header={enteteTabeau1}
        rowsPerPageOptions={[5, 10, 25, 50]}
        tableStyle={{ minWidth: "50rem" }}
        scrollable
        scrollDirection="horizontal"
        paginatorTemplate={
          "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
        }
        emptyMessage="Aucune fiche pour le moment"
        paginatorRight={
          <span style={{ margin: "10px", fontWeight: "bold" }}>
            Résultats : {filtreEnAttente.length}
          </span>
        }
      >
        <Column
          header="Date fiche"
          field="date_creation"
          bodyStyle={{ fontSize: "14px" }}
          body={(rowData) => {
            if (
              !rowData.date_creation ||
              rowData.date_creation === "0000-00-00"
            ) {
              return <span>Non fixé </span>;
            }
            const date = new Date(rowData.date_creation);
            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();

            return (
              <span>
                {day}/{month}/{year}
              </span>
            );
          }}
        />

        <Column header="Client" field="nom_prenom" />

        <Column
          style={{ cursor: "pointer" }}
          header="Téléphone"
          field="numero_tel"
          bodyStyle={{ fontSize: "14px" }}
          body={(rowData) => (
            <div>
              <span
                onClick={() => {
                  copyToClipboard(rowData.numero_tel);
                }}
              >
                {rowData.numero_tel}
              </span>
            </div>
          )}
        />

        <Column
          style={{ cursor: "pointer" }}
          header="Type trajet"
          field="type_trajet"
          bodyStyle={{ fontSize: "14px" }}
          body={(rowData) => (
            <div>
              <span
                onClick={() => {
                  copyToClipboard(rowData.type_trajet);
                }}
              >
                {rowData.type_trajet}
              </span>
            </div>
          )}
        />
        <Column
          style={{ cursor: "ponter" }}
          header="Trajet"
          field="trajet_detail"
          bodyStyle={{ fontSize: "14px" }}
          body={(rowData) => (
            <div>
              <span
                onClick={() => {
                  copyToClipboard(rowData.trajet_detail);
                }}
              >
                {mapTrajet(rowData.trajet_detail)}
              </span>
            </div>
          )}
        />

        <Column
          style={{ cursor: "pointer" }}
          header="Lieu"
          field="lieu_trajet"
          bodyStyle={{ fontSize: "14px" }}
          body={(rowData) => (
            <div>
              <span
                onClick={() => {
                  copyToClipboard(rowData.lieu_trajet);
                }}
              >
                {rowData.lieu_trajet}
              </span>
            </div>
          )}
        />

        <Column
          style={{ cursor: "pointer" }}
          header="Total"
          field="prix_total"
          bodyStyle={{ fontSize: "14px" }}
          body={(rowData) => (
            <div>
              <span
                onClick={() => {
                  copyToClipboard(rowData.prix_total);
                }}
              >
                {rowData.prix_total} €
              </span>
            </div>
          )}
        />

        <Column
          header="Actions"
          style={{ textAlign: "center", width: "100px" }}
          body={(rowData) => (
            <div
              style={{ display: "flex", justifyContent: "center", gap: "5px" }}
            >
              <Button
                icon="pi pi-file-edit"
                severity="success"
                size="small"
                onClick={() => {
                  setInfoClick(
                    rowData.id_navette,
                    rowData.nom_prenom,
                    rowData.numero_tel
                  );
                }}
              />
            </div>
          )}
        />
      </DataTable>
    </>
  );
}
